"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: babylon/epoching/v1/epoching.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validator = exports.DelegationLifecycle = exports.DelegationStateUpdate = exports.ValidatorLifecycle = exports.ValStateUpdate = exports.QueuedMessage = exports.Epoch = exports.BondState = exports.protobufPackage = void 0;
exports.bondStateFromJSON = bondStateFromJSON;
exports.bondStateToJSON = bondStateToJSON;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
const coin_1 = require("../../../cosmos/base/v1beta1/coin");
const tx_1 = require("../../../cosmos/staking/v1beta1/tx");
const timestamp_1 = require("../../../google/protobuf/timestamp");
exports.protobufPackage = "babylon.epoching.v1";
/** BondState is the bond state of a validator or delegation */
var BondState;
(function (BondState) {
    /** CREATED - CREATED is when the validator/delegation has been created */
    BondState[BondState["CREATED"] = 0] = "CREATED";
    /** BONDED - CREATED is when the validator/delegation has become bonded */
    BondState[BondState["BONDED"] = 1] = "BONDED";
    /** UNBONDING - CREATED is when the validator/delegation has become unbonding */
    BondState[BondState["UNBONDING"] = 2] = "UNBONDING";
    /** UNBONDED - CREATED is when the validator/delegation has become unbonded */
    BondState[BondState["UNBONDED"] = 3] = "UNBONDED";
    /** REMOVED - CREATED is when the validator/delegation has been removed */
    BondState[BondState["REMOVED"] = 4] = "REMOVED";
    BondState[BondState["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(BondState || (exports.BondState = BondState = {}));
function bondStateFromJSON(object) {
    switch (object) {
        case 0:
        case "CREATED":
            return BondState.CREATED;
        case 1:
        case "BONDED":
            return BondState.BONDED;
        case 2:
        case "UNBONDING":
            return BondState.UNBONDING;
        case 3:
        case "UNBONDED":
            return BondState.UNBONDED;
        case 4:
        case "REMOVED":
            return BondState.REMOVED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return BondState.UNRECOGNIZED;
    }
}
function bondStateToJSON(object) {
    switch (object) {
        case BondState.CREATED:
            return "CREATED";
        case BondState.BONDED:
            return "BONDED";
        case BondState.UNBONDING:
            return "UNBONDING";
        case BondState.UNBONDED:
            return "UNBONDED";
        case BondState.REMOVED:
            return "REMOVED";
        case BondState.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseEpoch() {
    return {
        epochNumber: 0,
        currentEpochInterval: 0,
        firstBlockHeight: 0,
        lastBlockTime: undefined,
        sealerAppHash: new Uint8Array(0),
        sealerBlockHash: new Uint8Array(0),
    };
}
exports.Epoch = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.epochNumber !== 0) {
            writer.uint32(8).uint64(message.epochNumber);
        }
        if (message.currentEpochInterval !== 0) {
            writer.uint32(16).uint64(message.currentEpochInterval);
        }
        if (message.firstBlockHeight !== 0) {
            writer.uint32(24).uint64(message.firstBlockHeight);
        }
        if (message.lastBlockTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.lastBlockTime), writer.uint32(34).fork()).join();
        }
        if (message.sealerAppHash.length !== 0) {
            writer.uint32(42).bytes(message.sealerAppHash);
        }
        if (message.sealerBlockHash.length !== 0) {
            writer.uint32(50).bytes(message.sealerBlockHash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEpoch();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.epochNumber = longToNumber(reader.uint64());
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.currentEpochInterval = longToNumber(reader.uint64());
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.firstBlockHeight = longToNumber(reader.uint64());
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.lastBlockTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.sealerAppHash = reader.bytes();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.sealerBlockHash = reader.bytes();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            epochNumber: isSet(object.epochNumber) ? globalThis.Number(object.epochNumber) : 0,
            currentEpochInterval: isSet(object.currentEpochInterval) ? globalThis.Number(object.currentEpochInterval) : 0,
            firstBlockHeight: isSet(object.firstBlockHeight) ? globalThis.Number(object.firstBlockHeight) : 0,
            lastBlockTime: isSet(object.lastBlockTime) ? fromJsonTimestamp(object.lastBlockTime) : undefined,
            sealerAppHash: isSet(object.sealerAppHash) ? bytesFromBase64(object.sealerAppHash) : new Uint8Array(0),
            sealerBlockHash: isSet(object.sealerBlockHash) ? bytesFromBase64(object.sealerBlockHash) : new Uint8Array(0),
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.epochNumber !== 0) {
            obj.epochNumber = Math.round(message.epochNumber);
        }
        if (message.currentEpochInterval !== 0) {
            obj.currentEpochInterval = Math.round(message.currentEpochInterval);
        }
        if (message.firstBlockHeight !== 0) {
            obj.firstBlockHeight = Math.round(message.firstBlockHeight);
        }
        if (message.lastBlockTime !== undefined) {
            obj.lastBlockTime = message.lastBlockTime.toISOString();
        }
        if (message.sealerAppHash.length !== 0) {
            obj.sealerAppHash = base64FromBytes(message.sealerAppHash);
        }
        if (message.sealerBlockHash.length !== 0) {
            obj.sealerBlockHash = base64FromBytes(message.sealerBlockHash);
        }
        return obj;
    },
    create(base) {
        return exports.Epoch.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEpoch();
        message.epochNumber = object.epochNumber ?? 0;
        message.currentEpochInterval = object.currentEpochInterval ?? 0;
        message.firstBlockHeight = object.firstBlockHeight ?? 0;
        message.lastBlockTime = object.lastBlockTime ?? undefined;
        message.sealerAppHash = object.sealerAppHash ?? new Uint8Array(0);
        message.sealerBlockHash = object.sealerBlockHash ?? new Uint8Array(0);
        return message;
    },
};
function createBaseQueuedMessage() {
    return {
        txId: new Uint8Array(0),
        msgId: new Uint8Array(0),
        blockHeight: 0,
        blockTime: undefined,
        msgCreateValidator: undefined,
        msgDelegate: undefined,
        msgUndelegate: undefined,
        msgBeginRedelegate: undefined,
        msgCancelUnbondingDelegation: undefined,
        msgEditValidator: undefined,
        msgUpdateParams: undefined,
    };
}
exports.QueuedMessage = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.txId.length !== 0) {
            writer.uint32(10).bytes(message.txId);
        }
        if (message.msgId.length !== 0) {
            writer.uint32(18).bytes(message.msgId);
        }
        if (message.blockHeight !== 0) {
            writer.uint32(24).uint64(message.blockHeight);
        }
        if (message.blockTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.blockTime), writer.uint32(34).fork()).join();
        }
        if (message.msgCreateValidator !== undefined) {
            tx_1.MsgCreateValidator.encode(message.msgCreateValidator, writer.uint32(42).fork()).join();
        }
        if (message.msgDelegate !== undefined) {
            tx_1.MsgDelegate.encode(message.msgDelegate, writer.uint32(50).fork()).join();
        }
        if (message.msgUndelegate !== undefined) {
            tx_1.MsgUndelegate.encode(message.msgUndelegate, writer.uint32(58).fork()).join();
        }
        if (message.msgBeginRedelegate !== undefined) {
            tx_1.MsgBeginRedelegate.encode(message.msgBeginRedelegate, writer.uint32(66).fork()).join();
        }
        if (message.msgCancelUnbondingDelegation !== undefined) {
            tx_1.MsgCancelUnbondingDelegation.encode(message.msgCancelUnbondingDelegation, writer.uint32(74).fork()).join();
        }
        if (message.msgEditValidator !== undefined) {
            tx_1.MsgEditValidator.encode(message.msgEditValidator, writer.uint32(82).fork()).join();
        }
        if (message.msgUpdateParams !== undefined) {
            tx_1.MsgUpdateParams.encode(message.msgUpdateParams, writer.uint32(90).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueuedMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.txId = reader.bytes();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.msgId = reader.bytes();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.blockHeight = longToNumber(reader.uint64());
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.blockTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.msgCreateValidator = tx_1.MsgCreateValidator.decode(reader, reader.uint32());
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.msgDelegate = tx_1.MsgDelegate.decode(reader, reader.uint32());
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.msgUndelegate = tx_1.MsgUndelegate.decode(reader, reader.uint32());
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.msgBeginRedelegate = tx_1.MsgBeginRedelegate.decode(reader, reader.uint32());
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.msgCancelUnbondingDelegation = tx_1.MsgCancelUnbondingDelegation.decode(reader, reader.uint32());
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.msgEditValidator = tx_1.MsgEditValidator.decode(reader, reader.uint32());
                    continue;
                }
                case 11: {
                    if (tag !== 90) {
                        break;
                    }
                    message.msgUpdateParams = tx_1.MsgUpdateParams.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            txId: isSet(object.txId) ? bytesFromBase64(object.txId) : new Uint8Array(0),
            msgId: isSet(object.msgId) ? bytesFromBase64(object.msgId) : new Uint8Array(0),
            blockHeight: isSet(object.blockHeight) ? globalThis.Number(object.blockHeight) : 0,
            blockTime: isSet(object.blockTime) ? fromJsonTimestamp(object.blockTime) : undefined,
            msgCreateValidator: isSet(object.msgCreateValidator)
                ? tx_1.MsgCreateValidator.fromJSON(object.msgCreateValidator)
                : undefined,
            msgDelegate: isSet(object.msgDelegate) ? tx_1.MsgDelegate.fromJSON(object.msgDelegate) : undefined,
            msgUndelegate: isSet(object.msgUndelegate) ? tx_1.MsgUndelegate.fromJSON(object.msgUndelegate) : undefined,
            msgBeginRedelegate: isSet(object.msgBeginRedelegate)
                ? tx_1.MsgBeginRedelegate.fromJSON(object.msgBeginRedelegate)
                : undefined,
            msgCancelUnbondingDelegation: isSet(object.msgCancelUnbondingDelegation)
                ? tx_1.MsgCancelUnbondingDelegation.fromJSON(object.msgCancelUnbondingDelegation)
                : undefined,
            msgEditValidator: isSet(object.msgEditValidator) ? tx_1.MsgEditValidator.fromJSON(object.msgEditValidator) : undefined,
            msgUpdateParams: isSet(object.msgUpdateParams) ? tx_1.MsgUpdateParams.fromJSON(object.msgUpdateParams) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.txId.length !== 0) {
            obj.txId = base64FromBytes(message.txId);
        }
        if (message.msgId.length !== 0) {
            obj.msgId = base64FromBytes(message.msgId);
        }
        if (message.blockHeight !== 0) {
            obj.blockHeight = Math.round(message.blockHeight);
        }
        if (message.blockTime !== undefined) {
            obj.blockTime = message.blockTime.toISOString();
        }
        if (message.msgCreateValidator !== undefined) {
            obj.msgCreateValidator = tx_1.MsgCreateValidator.toJSON(message.msgCreateValidator);
        }
        if (message.msgDelegate !== undefined) {
            obj.msgDelegate = tx_1.MsgDelegate.toJSON(message.msgDelegate);
        }
        if (message.msgUndelegate !== undefined) {
            obj.msgUndelegate = tx_1.MsgUndelegate.toJSON(message.msgUndelegate);
        }
        if (message.msgBeginRedelegate !== undefined) {
            obj.msgBeginRedelegate = tx_1.MsgBeginRedelegate.toJSON(message.msgBeginRedelegate);
        }
        if (message.msgCancelUnbondingDelegation !== undefined) {
            obj.msgCancelUnbondingDelegation = tx_1.MsgCancelUnbondingDelegation.toJSON(message.msgCancelUnbondingDelegation);
        }
        if (message.msgEditValidator !== undefined) {
            obj.msgEditValidator = tx_1.MsgEditValidator.toJSON(message.msgEditValidator);
        }
        if (message.msgUpdateParams !== undefined) {
            obj.msgUpdateParams = tx_1.MsgUpdateParams.toJSON(message.msgUpdateParams);
        }
        return obj;
    },
    create(base) {
        return exports.QueuedMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQueuedMessage();
        message.txId = object.txId ?? new Uint8Array(0);
        message.msgId = object.msgId ?? new Uint8Array(0);
        message.blockHeight = object.blockHeight ?? 0;
        message.blockTime = object.blockTime ?? undefined;
        message.msgCreateValidator = (object.msgCreateValidator !== undefined && object.msgCreateValidator !== null)
            ? tx_1.MsgCreateValidator.fromPartial(object.msgCreateValidator)
            : undefined;
        message.msgDelegate = (object.msgDelegate !== undefined && object.msgDelegate !== null)
            ? tx_1.MsgDelegate.fromPartial(object.msgDelegate)
            : undefined;
        message.msgUndelegate = (object.msgUndelegate !== undefined && object.msgUndelegate !== null)
            ? tx_1.MsgUndelegate.fromPartial(object.msgUndelegate)
            : undefined;
        message.msgBeginRedelegate = (object.msgBeginRedelegate !== undefined && object.msgBeginRedelegate !== null)
            ? tx_1.MsgBeginRedelegate.fromPartial(object.msgBeginRedelegate)
            : undefined;
        message.msgCancelUnbondingDelegation =
            (object.msgCancelUnbondingDelegation !== undefined && object.msgCancelUnbondingDelegation !== null)
                ? tx_1.MsgCancelUnbondingDelegation.fromPartial(object.msgCancelUnbondingDelegation)
                : undefined;
        message.msgEditValidator = (object.msgEditValidator !== undefined && object.msgEditValidator !== null)
            ? tx_1.MsgEditValidator.fromPartial(object.msgEditValidator)
            : undefined;
        message.msgUpdateParams = (object.msgUpdateParams !== undefined && object.msgUpdateParams !== null)
            ? tx_1.MsgUpdateParams.fromPartial(object.msgUpdateParams)
            : undefined;
        return message;
    },
};
function createBaseValStateUpdate() {
    return { state: 0, blockHeight: 0, blockTime: undefined };
}
exports.ValStateUpdate = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.state !== 0) {
            writer.uint32(8).int32(message.state);
        }
        if (message.blockHeight !== 0) {
            writer.uint32(16).uint64(message.blockHeight);
        }
        if (message.blockTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.blockTime), writer.uint32(26).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValStateUpdate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.state = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.blockHeight = longToNumber(reader.uint64());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.blockTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            state: isSet(object.state) ? bondStateFromJSON(object.state) : 0,
            blockHeight: isSet(object.blockHeight) ? globalThis.Number(object.blockHeight) : 0,
            blockTime: isSet(object.blockTime) ? fromJsonTimestamp(object.blockTime) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.state !== 0) {
            obj.state = bondStateToJSON(message.state);
        }
        if (message.blockHeight !== 0) {
            obj.blockHeight = Math.round(message.blockHeight);
        }
        if (message.blockTime !== undefined) {
            obj.blockTime = message.blockTime.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.ValStateUpdate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseValStateUpdate();
        message.state = object.state ?? 0;
        message.blockHeight = object.blockHeight ?? 0;
        message.blockTime = object.blockTime ?? undefined;
        return message;
    },
};
function createBaseValidatorLifecycle() {
    return { valAddr: "", valLife: [] };
}
exports.ValidatorLifecycle = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.valAddr !== "") {
            writer.uint32(10).string(message.valAddr);
        }
        for (const v of message.valLife) {
            exports.ValStateUpdate.encode(v, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorLifecycle();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.valAddr = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.valLife.push(exports.ValStateUpdate.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            valAddr: isSet(object.valAddr) ? globalThis.String(object.valAddr) : "",
            valLife: globalThis.Array.isArray(object?.valLife)
                ? object.valLife.map((e) => exports.ValStateUpdate.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.valAddr !== "") {
            obj.valAddr = message.valAddr;
        }
        if (message.valLife?.length) {
            obj.valLife = message.valLife.map((e) => exports.ValStateUpdate.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ValidatorLifecycle.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseValidatorLifecycle();
        message.valAddr = object.valAddr ?? "";
        message.valLife = object.valLife?.map((e) => exports.ValStateUpdate.fromPartial(e)) || [];
        return message;
    },
};
function createBaseDelegationStateUpdate() {
    return { state: 0, valAddr: "", amount: undefined, blockHeight: 0, blockTime: undefined };
}
exports.DelegationStateUpdate = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.state !== 0) {
            writer.uint32(8).int32(message.state);
        }
        if (message.valAddr !== "") {
            writer.uint32(18).string(message.valAddr);
        }
        if (message.amount !== undefined) {
            coin_1.Coin.encode(message.amount, writer.uint32(26).fork()).join();
        }
        if (message.blockHeight !== 0) {
            writer.uint32(32).uint64(message.blockHeight);
        }
        if (message.blockTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.blockTime), writer.uint32(42).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDelegationStateUpdate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.state = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.valAddr = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.amount = coin_1.Coin.decode(reader, reader.uint32());
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.blockHeight = longToNumber(reader.uint64());
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.blockTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            state: isSet(object.state) ? bondStateFromJSON(object.state) : 0,
            valAddr: isSet(object.valAddr) ? globalThis.String(object.valAddr) : "",
            amount: isSet(object.amount) ? coin_1.Coin.fromJSON(object.amount) : undefined,
            blockHeight: isSet(object.blockHeight) ? globalThis.Number(object.blockHeight) : 0,
            blockTime: isSet(object.blockTime) ? fromJsonTimestamp(object.blockTime) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.state !== 0) {
            obj.state = bondStateToJSON(message.state);
        }
        if (message.valAddr !== "") {
            obj.valAddr = message.valAddr;
        }
        if (message.amount !== undefined) {
            obj.amount = coin_1.Coin.toJSON(message.amount);
        }
        if (message.blockHeight !== 0) {
            obj.blockHeight = Math.round(message.blockHeight);
        }
        if (message.blockTime !== undefined) {
            obj.blockTime = message.blockTime.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.DelegationStateUpdate.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDelegationStateUpdate();
        message.state = object.state ?? 0;
        message.valAddr = object.valAddr ?? "";
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? coin_1.Coin.fromPartial(object.amount)
            : undefined;
        message.blockHeight = object.blockHeight ?? 0;
        message.blockTime = object.blockTime ?? undefined;
        return message;
    },
};
function createBaseDelegationLifecycle() {
    return { delAddr: "", delLife: [] };
}
exports.DelegationLifecycle = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.delAddr !== "") {
            writer.uint32(10).string(message.delAddr);
        }
        for (const v of message.delLife) {
            exports.DelegationStateUpdate.encode(v, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDelegationLifecycle();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.delAddr = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.delLife.push(exports.DelegationStateUpdate.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            delAddr: isSet(object.delAddr) ? globalThis.String(object.delAddr) : "",
            delLife: globalThis.Array.isArray(object?.delLife)
                ? object.delLife.map((e) => exports.DelegationStateUpdate.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.delAddr !== "") {
            obj.delAddr = message.delAddr;
        }
        if (message.delLife?.length) {
            obj.delLife = message.delLife.map((e) => exports.DelegationStateUpdate.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.DelegationLifecycle.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDelegationLifecycle();
        message.delAddr = object.delAddr ?? "";
        message.delLife = object.delLife?.map((e) => exports.DelegationStateUpdate.fromPartial(e)) || [];
        return message;
    },
};
function createBaseValidator() {
    return { addr: new Uint8Array(0), power: 0 };
}
exports.Validator = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.addr.length !== 0) {
            writer.uint32(10).bytes(message.addr);
        }
        if (message.power !== 0) {
            writer.uint32(16).int64(message.power);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.addr = reader.bytes();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.power = longToNumber(reader.int64());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            addr: isSet(object.addr) ? bytesFromBase64(object.addr) : new Uint8Array(0),
            power: isSet(object.power) ? globalThis.Number(object.power) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.addr.length !== 0) {
            obj.addr = base64FromBytes(message.addr);
        }
        if (message.power !== 0) {
            obj.power = Math.round(message.power);
        }
        return obj;
    },
    create(base) {
        return exports.Validator.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseValidator();
        message.addr = object.addr ?? new Uint8Array(0);
        message.power = object.power ?? 0;
        return message;
    },
};
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(globalThis.String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1_000);
    const nanos = (date.getTime() % 1_000) * 1_000_000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (t.seconds || 0) * 1_000;
    millis += (t.nanos || 0) / 1_000_000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new globalThis.Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function longToNumber(int64) {
    const num = globalThis.Number(int64.toString());
    if (num > globalThis.Number.MAX_SAFE_INTEGER) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (num < globalThis.Number.MIN_SAFE_INTEGER) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return num;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=epoching.js.map